<!-- Start: Rejwan: 14-05-2025 Deregistration -->
<template>
    <div>
        <b-modal size="lg" id="bv-modal-process-settlement" hide-footer
            :title="'Process settlement for ' + employee_name">
            <!-- {{onAmountChange}} -->

            <b-overlay :show="showoverlaymodal" class='showoverlay_settle' rounded="sm">
                <!-- Start: Rejwan -->
                <b-form @submit.stop.prevent="deregistrationSubmit">
                    <div class="clearfix">
                        <div class="col-md-12">
                            <div class="row clearfix">
                                <div class="col-md-4 float-left">
                                    <dl class="row clearfix py-2 company-form-container no-border no-shadow">
                                        <dt class="col-md-12 pl-0 pr-0">Settlement Application Date</dt>
                                        <b-form-input id="application_date" name="application_date"
                                            v-model="fdata.application_date" disabled></b-form-input>
                                    </dl>

                                    <b-form-group id="settlement_type-group" label="Type of Settlement"
                                        label-for="settlement_type" class="required-field "><!-- Mustafijur: 24-08-2026 -->
                                        <b-form-select id="settlement_type" name="settlement_type" data-vv-as="Type of Settlement"
                                            :state="validateState('settlement_type')" v-model="fdata.settlement_type"
                                            :options="settlementOptions" v-validate="{ required: true }">
                                        </b-form-select>
                                        <b-form-invalid-feedback id="settlement_type-feedback">{{
                                            veeErrors.first('settlement_type') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                    

                                    <!-- <dl class="row clearfix py-2 company-form-container no-border no-shadow">
                                        <dt class="col-md-12 pl-0 pr-0">Reason for Separation</dt>
                                        <b-form-input id="reason_for_separation" name="reason_for_separation"
                                            v-model="fdata.reason_for_separation" disabled></b-form-input>
                                    </dl> -->
                                    <b-form-group  id="separation-reason-group" label="Reason for Settlement" class="required-field" label-for="reason_for_separation ">
                                        <b-form-select
                                            id="reason_for_separation" name="reason_for_separation" data-vv-as="Reason For Settlement" :state="validateState('reason_for_separation')"
                                            :options="settlementReasonOptions" v-model="fdata.reason_for_separation" v-validate="{ required: true }" disabled>
                                        </b-form-select>
                                            <b-form-invalid-feedback id="reason_for_separation-feedback">{{ veeErrors.first('reason_for_separation') }}</b-form-invalid-feedback>
                                    </b-form-group>

                                </div>

                                <div class="col-md-8 float-right">
                                    <!-- <div class="d-flex">
                                        <div class="col-md-6 pl-0" style="color: #004242; font-weight: 500;">
                                            <div class="py-2">Employee Code</div>
                                            <div class="py-2">Employee Name</div>
                                            <div class="py-2">Joining Date</div>
                                            <div class="py-2">Leaving Date</div>
                                            <div class="py-2">Confirmation Date</div>
                                            <div class="py-2">Service Period</div>
                                            <div class="py-2">Eligible Service Period</div>
                                            <div class="py-2">GF Balance Payable</div>
                                            <div class="py-2">GF Paid</div>
                                        </div>
                                        <div class="col-md-6 pl-0 pr-0">
                                            <div class="py-2">{{ fdata.employee_code }}</div>
                                            <div class="py-2">{{ fdata.employee_name }}</div>
                                            <div class="py-2">{{ fdata.joining_date }}</div>
                                            <div class="py-2">{{ fdata.leaving_date }}</div>
                                            <div class="py-2">{{ fdata.gf_confirmation_date }}</div>
                                            <div class="py-2">{{ fdata.service_period }}</div>
                                            <div class="py-2">{{ fdata.service_period }}</div>
                                            <div class="py-2">{{ fdata.payable_amount }}</div>
                                            <div class="py-2">{{ fdata.paid_amount }}</div>
                                        </div>
                                    </div> -->

                                    <div class="d-flex py-2">
                                        <div class="col-md-6 pl-0" style="color:#004242;font-weight:500;">Employee Code</div>
                                        <div class="col-md-6 pl-0 pr-0">{{ fdata.employee_code }}</div>
                                    </div>
                                    <div class="d-flex py-2">
                                        <div class="col-md-6 pl-0" style="color:#004242;font-weight:500;">Employee Name</div>
                                        <div class="col-md-6 pl-0 pr-0">{{ fdata.employee_name }}</div>
                                    </div>
                                    <div class="d-flex py-2">
                                        <div class="col-md-6 pl-0" style="color:#004242;font-weight:500;">Joining Date</div>
                                        <div class="col-md-6 pl-0 pr-0">{{ fdata.joining_date }}</div>
                                    </div>
                                    <div class="d-flex py-2">
                                        <div class="col-md-6 pl-0" style="color:#004242;font-weight:500;">Leaving Date</div>
                                        <div class="col-md-6 pl-0 pr-0">{{ fdata.leaving_date }}</div>
                                    </div>
                                    <div class="d-flex py-2">
                                        <div class="col-md-6 pl-0" style="color:#004242;font-weight:500;">Service Period</div>
                                        <div class="col-md-6 pl-0 pr-0">{{ fdata.service_period }}</div>
                                    </div>
                                    <div class="d-flex py-2">
                                        <div class="col-md-6 pl-0" style="color:#004242;font-weight:500;">GF Balance Payable</div>
                                        <div class="col-md-6 pl-0 pr-0">{{ fdata.payable_amount }}</div>
                                    </div>
                                    <div class="d-flex py-2">
                                        <div class="col-md-6 pl-0" style="color:#004242;font-weight:500;">GF Paid</div>
                                        <div class="col-md-6 pl-0 pr-0">{{ fdata.paid_amount }}</div>
                                    </div> 
                                </div>
                                 <!--Start: Sifat: 07-07-2025 Check GF Module -->
                                <div class="col-md-4">
                                    <b-form-group id="settlement_amount-group" label="Settlement Amount"
                                        label-for="settlement_amount" class="required-field">
                                        <b-form-input id="settlement_amount" name="settlement_amount"
                                            v-model="fdata.settlement_amount"
                                            v-validate="{ required: true, regex: /^[0-9]*\.?[0-9]{0,3}$/, max_value: fdata.net_payable_amount }"
                                            :state="validateState('settlement_amount')"
                                            aria-describedby="settlement_amount-feedback"
                                            data-vv-as="Settlement Amount"></b-form-input>
                                        <b-form-invalid-feedback id="settlement_amount-feedback">{{
                                            veeErrors.first('settlement_amount') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group id="tax_deduction_at_source-group" label="Tax Deducted at Source"
                                        label-for="tax_deduction_at_source" class="required-field">
                                        <b-form-input id="tax_deduction_at_source" name="tax_deduction_at_source"
                                            v-model="fdata.tds_amount"
                                            v-validate="{ required: true, regex: /^[0-9]*\.?[0-9]{0,3}$/, max_value: fdata.net_payable_amount }"
                                            :state="validateState('tax_deduction_at_source')"
                                            aria-describedby="tax_deduction_at_source-feedback"
                                            data-vv-as="Tax Deducted at Source"></b-form-input>
                                        <b-form-invalid-feedback id="tax_deduction_at_source-feedback">{{
                                            veeErrors.first('tax_deduction_at_source') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                    <b-form-group id="net_settlement_payable-group" label="Net Settlement Payable"
                                        label-for="net_settlement_payable" class="required-field">
                                        <b-form-input id="net_settlement_payable" name="net_settlement_payable"
                                            v-model="fdata.net_settlement_payable"
                                            v-validate="{ required: true, regex: /^[0-9]*\.?[0-9]{0,3}$/, max_value: fdata.net_payable_amount }"
                                            aria-describedby="net_settlement_payable-feedback"
                                            data-vv-as="Net Settlement Payable" readonly></b-form-input>
                                        <b-form-invalid-feedback id="net_settlement_payable-feedback">{{
                                            veeErrors.first('net_settlement_payable') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                                <div class="col-md-4">
                                </div>
                                <!--End: Sifat: 07-07-2025 Check GF Module -->

                                <div v-if="fdata.id > 0" class="col-md-4 float-right">
                                    <div class="col-md-12 text-center mt-4 pt-2">
                                        <b-button class="btn-primary" variant="success" @click="showAttachments"> View
                                            Attachments </b-button>
                                    </div>
                                </div>

                                <!-- <div class="col-md-4 float-right">
                                    <div class="col-md-12 text-center mt-4 pt-2">
                                        <b-button class="btn-primary" variant="success" @click="showBankInfo()"> View
                                            Bank Details </b-button>
                                    </div>
                                </div> -->

                                <div v-if="fdata.id == 0" class="col-12 float-right">
                                    <div class="col-md-12 text-center mt-4 pt-2">
                                        <file-component ref="fileinput" :labelname="this.attachment"
                                            :accept="this.accept" :multiple="this.multiple"
                                            v-on:childToParent="listReturnAttachment"></file-component>
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <b-form-group id="remarks-group" label="Remarks" class="required-field"
                                        label-for="remarks">
                                        <b-form-textarea id="remarks" :state="validateState('remarks')" name="remarks"
                                            v-model="fdata.remarks" v-validate="{ required: true }" rows="3"
                                            max-rows="6" no-resize aria-describedby="remarks-feedback"
                                            data-vv-as="Remarks"></b-form-textarea>
                                        <b-form-invalid-feedback id="remarks-feedback">{{ veeErrors.first('remarks')
                                        }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 float-right">
                            <div class="col-md-12 text-center mt-5">
                                <b-button type="submit" class="btn-primary" variant="success"> Submit </b-button>
                            </div>
                        </div>
                    </div>
                </b-form>

                <!-- End: Rejwan -->
            </b-overlay>
        </b-modal>

        <b-modal id="show_attachments" size="lg" hide-footer title="Advance Files" scrollable>
            <gf-loan-documents :pageurl="this.$api_url" flg="1" :key="flg_key" :loan_id="fdata.id"></gf-loan-documents>
        </b-modal>

        <b-modal id="bv-modal-bank" size="lg" hide-footer title="Bank Info">
            <gf-loan-bank-data-form :pageurl="this.$api_url" :employee_id="employee_id"
                :bdata="bdata"></gf-loan-bank-data-form>
        </b-modal>
    </div>
</template>
<script>

export default {

    mounted() {
        this.updateNetSettlementPayable();

    },
    props: ['flg', 'pageurl', 'settlement_id', 'settlement_data', 'employee_id', 'employee_name', 'form_status'],
    components: {

    },
    // Start: Sifat: 07-07-2025 Check GF Module
    watch: {
        'fdata.settlement_amount'(newVal) {
            this.updateNetSettlementPayable();
        },
        'fdata.tds_amount'(newVal) {
            this.updateNetSettlementPayable();
        }
    },
    // End: Sifat: 07-07-2025 Check GF Module
    data() {


        return {
            // Start: Rejwan
            settlementOptions: [{ text: 'Select Settlement Type', value: null }, { text: 'Final Settlement', value: 0 }, { text: 'Partial Settlement', value: 1 }],
            fdata: {
                employee_id: 0,
                settlement_type: null,
                application_date: null,
                reason_for_separation: null,
                employee_code: null,
                employee_name: null,
                joining_date: null,
                leaving_date: null,
                gf_confirmation_date: null,
                service_period: null,
                eligible_service_period: null,
                payable_amount: null,
                net_payable_amount: null,
                settlement_amount: null,
                remarks: null,
                bank_id: 0,
                tds_amount: 0, //Sifat: 07-07-2025 Check GF Module
                net_settlement_payable: 0, //Sifat: 07-07-2025 Check GF Module
                settlementReasonOptions : [],
            },
            flg_key: 0,

            accept: ".jpg, .png, .gif, .pdf , .doc , .docx",
            attachment: 'Attachments',
            multiple: true,
            attachment: 'Upload File',
            document: null,
            bdata: null,


            // End: Rejwan

            showoverlaymodal: false,
            disabled: true,
        }
    },
    methods: {
        // Start: Rejwan:
        listReturnAttachment: function (data) {
            // Start: Rejwan: 30-04-2025 File Upload
            this.document = data;
            // End: Rejwan: 30-04-2025 File Upload
        },
        showAttachments() {
            this.$bvModal.show('show_attachments');
            this.flg_key += 1;
        },

        showBankInfo: function () {
            this.$bvModal.show('bv-modal-bank');
        },
        getBankInfo: function (employee_id) {
            let currentObj = this;
            axios.get(this.$api_url + '/gf/employee/bank-info', {
                params: {
                    employee_id: employee_id
                }
            }).then(function (response) {
                this.bdata = response.data;
            }.bind(this)).catch(function (error) {
                currentObj.showoverlay = false;
            });
        },

        resetForm() {
            this.fdata = {
                employee_id: 0,
                id: 0,
                settlement_type: null,
                application_date: null,
                reason_for_separation: null,
                employee_code: null,
                employee_name: null,
                joining_date: null,
                leaving_date: null,
                gf_confirmation_date: null,
                service_period: null,
                eligible_service_period: null,
                payable_amount: null,
                net_payable_amount: null,
                settlement_amount: null,
                remarks: null,
                settlement_status: null,
                bank_id: 0,
            },
                this.document = null;

        },

        deregistrationSubmit(e) {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }
            let currentObj = this;
            let formData = new FormData();
            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                currentObj.showoverlaymodal = true;
                // if(this.settlement_fdata.id > 0)

                if (this.fdata.id > 0) {
                    // var url = this.$api_url+'/pf/settlement-approval/update';
                }
                // else if(this.settlement_fdata.id == 0)
                else if (this.fdata.id == 0) {
                    var url = this.$api_url + '/gf/settlement/save';
                    this.fdata.employee_id = this.employee_id;
                    this.fdata.settlement_status = 0;
                    this.fdata.bank_id = this.bdata.id;

                    for (let [key, value] of Object.entries(this.fdata)) {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }

                    if (this.document && this.document.length) {
                        this.document.forEach((file, index) => {
                            formData.append('document[]', file);
                        });
                    } else {
                        formData.append('document', '');
                    }
                }

                axios.post(url, formData, config)
                    .then(function (response) {
                        if (response.data.success) {
                            currentObj.$bvToast.toast(response.data.message, { title: 'Success', variant: 'success', solid: true });
                        } else {
                            if (response.data.message) {
                                currentObj.$bvToast.toast(response.data.message, {
                                    title: `Error`,
                                    variant: 'danger',
                                    solid: true
                                });
                            } else {
                                currentObj.$bvToast.toast("Application Submitted", {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                            }

                        }
                        currentObj.$bvModal.hide('bv-modal-process-settlement');
                        currentObj.showoverlaymodal = false;

                    }.bind(currentObj))
                    .catch(function (error) {
                        currentObj.showoverlaymodal = false;

                    });
            });

        },
        // Start: Rejwan
        processGfSettlement: function (employee_id) {
            let currentObj = this;
            currentObj.showoverlay = true;
            axios.get(this.$api_url + '/gf/employee/data', {
                params: {
                    employee_id: employee_id,
                }

            }).then(function (response) {
                this.fdata = response.data;
                this.fdata.settlement_type = null;
                this.fdata.net_payable_amount = response.data.settlement_amount;
                this.$bvModal.show('bv-modal-process-settlement');
                currentObj.showoverlay = false;
                console.log("response: ", response.data);

                this.getReasons();


            }.bind(this)).catch(function (error) {
                currentObj.showoverlay = false;
            });
        },
        // End: Rejwan
        //Start: Sifat: 07-07-2025 Check GF Module
        updateNetSettlementPayable() {
            const amount = parseFloat(this.fdata.settlement_amount) || 0;
            const tds = parseFloat(this.fdata.tds_amount) || 0;
            this.fdata.net_settlement_payable = this.calCulateNetSettlementPayable(amount, tds);
            // console.log();


        },

        calCulateNetSettlementPayable(payable_amount, tds_amount) {
            return payable_amount - tds_amount;
        },
        //End: Sifat: 07-07-2025 Check GF Module

        getReasons: function() {
            if(!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url+'/gf/default-settl-reasons', {
                params: { 'quick_view': 0 }
            }).then(function(response) {
                if(response.data) {
                    this.settlementReasonOptions = [
                        { value: null, text: "Select Settlement Reason" },
                        { value: response.data.id, text: response.data.title }
                    ];
                   
                    this.$nextTick(function() {
                        this.fdata.reason_for_separation = response.data.id;
                    }.bind(this));
                }
            }.bind(this))   
        },

    },
    created: function () {
        // Start: Rejwan
        this.getBankInfo(this.employee_id);
        if (this.settlement_id == 0 && this.employee_id > 0) {
            this.processGfSettlement(this.employee_id);
        }
        else if (this.settlement_id > 0 && this.employee_id > 0) {
            setTimeout(() => {

                this.fdata = this.settlement_data;
                this.processGfSettlement(this.employee_id);

            }, 1000);

        }
        //   End: Rejwan
    },
}
</script>
<style scoped>
#bv-modal-process-settlement .form-control.is-valid {
    padding-right: .75rem !important;
    z-index: 1;
}

/* Start: Rejwan: 16-02-2025 */
.error-message {
    white-space: normal;
}

/* End: Rejwan: 16-02-2025 */
</style>
<!-- End: Rejwan: 14-05-2025 Deregistration -->
